<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <b-row class="mx-0 mb-3">
      <b-col lg="12">
        <b-card
          title="Archives"
          sub-title="Recupération des documents générés par le Recuperator"
          bg-variant="secondary"
        >
          <!-- <b-button @click="load()">Reload</b-button> -->
          <b-row v-if="loaded">
            <b-col lg="12" v-if="archives.commissions.length > 0">
              <b-card header="Factures commissions">
                <b-table :items="archives.commissions" :fields="archivesFields">
                  <template v-slot:cell(actions)="data">
                    <b-button
                      style="font-weight: inherit"
                      :href="
                        $store.getters.url +
                        '/upload/documents/commissions/' +
                        data.item.file
                      "
                      target="_blank"
                      >Visualiser le document</b-button
                    >
                  </template>
                </b-table>
              </b-card>
            </b-col>
            <b-col lg="12" class="mt-3" v-if="archives.md.length > 0">
              <b-card header="Mises en demeure">
                <b-table :items="archives.md" :fields="archivesFields">
                  <template v-slot:cell(actions)="data">
                    <b-button
                      style="font-weight: inherit"
                      :href="
                        $store.getters.url +
                        '/upload/documents/md/' +
                        data.item.file
                      "
                      target="_blank"
                      >Visualiser le document</b-button
                    >
                  </template>
                </b-table>
              </b-card>
            </b-col>
            <b-col lg="12" class="mt-3" v-if="archives.rappels.length > 0">
              <b-card header="Rappels arrangement">
                <b-table :items="archives.rappels" :fields="archivesFields">
                  <template v-slot:cell(actions)="data">
                    <b-button
                      style="font-weight: inherit"
                      :href="
                        $store.getters.url +
                        '/upload/documents/rappels/' +
                        data.item.file
                      "
                      target="_blank"
                      >Visualiser le document</b-button
                    >
                  </template>
                </b-table>
              </b-card>
            </b-col>
            <b-col lg="12" class="mt-3" v-if="archives.releves.length > 0">
              <b-card header="Relevés de compte">
                <b-table :items="archives.releves" :fields="archivesFields"
                  ><template v-slot:cell(actions)="data">
                    <b-button
                      style="font-weight: inherit"
                      :href="
                        $store.getters.url +
                        '/upload/documents/releves/' +
                        data.item.file
                      "
                      target="_blank"
                      >Visualiser le document</b-button
                    >
                  </template>
                </b-table>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import DateTime from "@/services/DateTime.js";
import archives from "@/services/archives.js";
export default {
  name: "Archives",
  data() {
    return {
      archives: [],
      loaded: false,
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Administration",
          to: { name: "administration" },
        },
        {
          text: "Archives",
          active: true,
        },
      ],
      archivesFields: [
        {
          key: "file",
          label: "Fichier",
          sortable: true,
        },
        {
          key: "mtime",
          label: "Date",
          formatter: (value) => this.toDateTime(value),
          class: "text-center",
        },
        {
          key: "actions",
          label: "Action",
          class: "text-center",
        },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      archives.list().then((response) => {
        this.archives = response.data;
        this.loaded = true;
      });
    },
    toPath() {
      return "";
    },
    toDateTime(d) {
      return DateTime.humanDateTime(d);
    },
    ucfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>
